<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormRadioButton fieldName="client_category"
                                         label="Lead type"
                                         validation="required"
                                         size="2"
                                         containerClass="radio-button"
                                         optionClass="radio-button-option"
                                         :isFormDisabled="isFormDisabled"
                                         :data="select?.client_categories"
                                         :onchange="(e) => clientCategoryChanged(e)"
                                         v-model:field="crud.client_category" />

                        <FormInputText fieldName="first_name"
                                       label="First name"
                                       validation="required"
                                       size="2"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.first_name" />

                        <FormInputText fieldName="last_name"
                                       label="Last name"
                                       validation="required"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.last_name" />

                        <template v-if="isCompanyNameRequired">
                            <FormInputText fieldName="company_name"
                                           label="Company name"
                                           size="3"
                                           :validation="isCompanyNameRequired ? 'required' : null"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.company_name" />

                            <FormInputText fieldName="position"
                                           label="Position"
                                           size="2"
                                           :isFormDisabled="isFormDisabled"
                                           v-model:field="crud.position" />
                        </template>
                        <template v-else>
                            <FormStaticText label=""
                                            size="5" />
                        </template>
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="status_id"
                                    label="Status"
                                    size="4"
                                    :isFormDisabled="true"
                                    :options="select?.statuses"
                                    v-model:field="crud.status_id" />

                        <FormSelect fieldName="dctcategory_id"
                                    label="Category"
                                    size="4"
                                    validation="required"
                                    :showClear="true"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.dct_lead_categories"
                                    v-model:field="crud.dctcategory_id" />

                        <FormSelect fieldName="dctsource_id"
                                    label="Lead source"
                                    size="4"
                                    validation="required"
                                    :showClear="true"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.dct_lead_sources"
                                    v-model:field="crud.dctsource_id" />
                    </div>
                    <div class="grid">
                        <FormRadioButton fieldName="service_type"
                                         label="Service type"
                                         containerClass="radio-button"
                                         optionClass="radio-button-option"
                                         validation="required"
                                         size="2"
                                         :isFormDisabled="isFormDisabled"
                                         :data="select?.service_types"
                                         :change="serviceTypeChanged"
                                         v-model:field="crud.service_type" />

                        <FormSelect fieldName="service_id"
                                    label="Service"
                                    size="4"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.services"
                                    v-model:field="crud.service_id" />
                        <FormSelect fieldName="trader_id"
                                    label="Trader"
                                    size="3"
                                    :showClear="true"
                                    :isFormDisabled="isFormDisabled"
                                    :options="select?.users"
                                    v-model:field="crud.trader_id" />

                        <FormSelect fieldName="creator_id"
                                    label="Creator"
                                    size="3"
                                    :isFormDisabled="true"
                                    :options="select?.users"
                                    v-model:field="crud.creator_id" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="3"
                                       :inputClass="contactValidation == 'E' ? 'required-field' : ''"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.email" />

                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="3"
                                       :inputClass="contactValidation == 'T' ? 'required-field' : ''"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.phone" />

                        <FormCalendar fieldName="lead_date"
                                      label="Lead date"
                                      size="2"
                                      validation="required"
                                      :isFormDisabled="isFormDisabled"
                                      v-model:field="crud.lead_date" />

                        <FormInputText fieldName="recommended_by"
                                       label="Recommended by"
                                       size="4"
                                       v-model:field="crud.recommended_by" />
                    </div>
                    <div class="grid">
                        <FormRadioButton fieldName="contact_method"
                                         label="Contact method"
                                         containerClass="radio-button"
                                         optionClass="radio-button-option"
                                         validation="required"
                                         size="2"
                                         :isFormDisabled="isFormDisabled"
                                         :data="select?.contact_methods"
                                         :onchange="(e) => contactMethodChanged(e)"
                                         v-model:field="crud.contact_method" />
                        <FormInputText fieldName="contact_terms"
                                       label="Contact terms"
                                       size="10"
                                       v-model:field="crud.contact_terms" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="subject"
                                       label="Subject"
                                       validation="required"
                                       v-model:field="crud.subject" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="message"
                                    label="Demand details"
                                    validation="required"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.message" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="city"
                                       label="City"
                                       size="3"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.city" />
                        <FormInputMask fieldName="postal_code"
                                       label="Postal code"
                                       size="1"
                                       mask="99-999"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.postal_code" />
                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="8"
                                       :isFormDisabled="isFormDisabled"
                                       v-model:field="crud.address" />
                    </div>

                    <div class="grid">
                        <FormInputNumber fieldName="budget_assumed"
                                         label="Budget assumed"
                                         size="3"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.budget_assumed" />
                        <FormInputNumber fieldName="sales_potential"
                                         label="Sales potential"
                                         size="3"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.sales_potential" />
                        <FormInputNumber fieldName="conversion_chance"
                                         label="Conversion chance (%)"
                                         size="3"
                                         suffix="%"
                                         :min="0"
                                         :max="100"
                                         :step="5"
                                         :showButtons="true"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.conversion_chance" />
                    </div>

                    <div v-if="isLeadRefused"
                         class="grid">
                        <FormInputText fieldName="refuse_reason"
                                       label="Refuse reason"
                                       :isFormDisabled="true"
                                       v-model:field="crud.refuse_reason" />
                    </div>
                    <div class="grid">
                        <FormEditor fieldName="description"
                                    label="Description"
                                    :isFormDisabled="isFormDisabled"
                                    v-model:field="crud.description" />
                    </div>
                    <div class="grid">
                        <FormFileUploader fieldName="files"
                                          label="Attachments"
                                          category="documents"
                                          :allowedExtensions="['pdf', 'docx', 'xlsx', 'txt']"
                                          :style="{ minWidth: '200px' }"
                                          :isFormDisabled="isFormDisabled"
                                          v-model:field="crud.files" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         :afterSave="() => refreshAlertsIfNeeded()"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-show="buttonProps">
                    <span style="margin-right:25px"></span>
                    <span>
                        <CustomButton v-if="setRefuseCondition"
                                      name="setRefuse"
                                      @click.stop="setRefuse"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('teal')">
                            <template class="flex items-center gap-1"><i class="fa-regular fa-circle-xmark"></i><span>{{ __('Refuse') }}</span></template>
                        </CustomButton>
                    </span>
                    <span>
                        <CustomButton v-if="setClassifyCondition"
                                      name="setClassify"
                                      @click.stop="setClassify"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('blue')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-dolly"></i><span>{{ __('Classify') }}</span></template>
                        </CustomButton>
                    </span>
                    <span>
                        <CustomButton v-if="convertToOpportunityCondition"
                                      name="convertToOpportunity"
                                      style="width:200px"
                                      @click.stop="openConvertConfirmationWindow"
                                      :buttonProps="buttonProps"
                                      :className="buttonClass('indigo')">
                            <template class="flex items-center gap-1"><i class="fa-solid fa-arrow-trend-up"></i><span>{{ __('Convert to opportunity') }}</span></template>
                        </CustomButton>
                    </span>
                </template>

                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'leads', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>

    <Dialog modal
            v-model:visible="isSetRefuseModalOpen"
            :header="__('Refuse lead')"
            :unstyled="false"
            :style="{ width: '50%' }"
            :pt="dialogPt">
        <SetRefuseForm :leadData="leadData"
                       :formProps="leadFormProps"
                       v-model:isSetRefuseModalOpen="isSetRefuseModalOpen">
        </SetRefuseForm>
    </Dialog>

    <Dialog modal
            v-model:visible="isSetClassifyModalOpen"
            :header="__('Classify lead')"
            :unstyled="false"
            :style="{ width: '50%' }"
            :pt="dialogPt">
        <SetClassifyForm :leadData="leadData"
                         :formProps="leadFormProps"
                         v-model:isSetClassifyModalOpen="isSetClassifyModalOpen">
        </SetClassifyForm>
    </Dialog>

    <ConfirmDialog header="Confirm operation"
                   question="Do you want to convert lead to opportunity?"
                   v-model="isConvertConfirmationOpen"
                   :operation="convertToOpportunity">
    </ConfirmDialog>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormAutocomplete from '@crud/FormAutocomplete.vue'
import FormEditor from '@crud/FormEditor.vue'
import FormButtons from '@crud/FormButtons.vue'
import FormRadioButton from '@crud/FormRadioButton.vue'
import FormStaticText from '@crud/FormStaticText.vue'
import FormInputMask from '@crud/FormInputMask.vue'
import FormCalendar from '@crud/FormCalendar.vue';
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormFileUploader from '@crud/FormFileUploader.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import CustomButton from '@crud/CustomButton.vue'
import Dialog from 'primevue/dialog';
import ConfirmDialog from '@crud/ConfirmDialog.vue'
import SetRefuseForm from './SetRefuseForm.vue'
import SetClassifyForm from './SetClassifyForm.vue'
import { validation, initFormObj, prepareSelect } from '@pages/Helper/crud_utils.js'
import { __, getStoreValue, getStatusId, getAllStatuses, getFromRoute, buttonClass, screenMessage, currentDate } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const buttonsVisibility = ref(null);

const isCompanyNameRequired = ref(false);
const contactValidation = ref('T');

const options = ["client_categories", "dct_lead_categories", "dct_lead_sources", "users", "services", "service_types", "contact_methods", "statuses"];
const select = ref(null);
const isAddAlertDialogOpen = ref(false);
const isLeadRefused = ref(false);

const setRefuseCondition = ref(false)
const setClassifyCondition = ref(false)
const convertToOpportunityCondition = ref(false)

const isSetRefuseModalOpen = ref(false);
const isSetClassifyModalOpen = ref(false);
const isConvertConfirmationOpen = ref(false);

const leadData = ref({})
const leadFormProps = ref({})

let previousTraderId = null;

const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, options, select, buttonsVisibility, paramsToSelect: { 'statuses': { 'status_category': 'STA_LEAD' } } })
    previousTraderId = crud.value.trader_id;

    if (props.formProps.addMode == true) {
        crud.value.creator_id = getStoreValue('myId');
        crud.value.status_id = await getStatusId('STA_LEAD', 'SYM_NEW');
        crud.value.lead_date = currentDate();
        crud.value.client_category = 'P';
        crud.value.contact_method = 'E';
        crud.value.service_type = 'O';
    } else {
        let allStatuses = await getAllStatuses('STA_LEAD');

        isLeadRefused.value = crud.value.status_id == allStatuses.find(s => s.status_symbol == 'SYM_REFUSED')?.id;

        setButtonsConditions(['SYM_NEW', 'SYM_ASSIGNED', 'SYM_CONTACTED', 'SYM_CLASSIFIED'], setRefuseCondition, allStatuses)
        setButtonsConditions(['SYM_NEW', 'SYM_ASSIGNED', 'SYM_CONTACTED'], setClassifyCondition, allStatuses)
        setButtonsConditions(['SYM_CLASSIFIED'], convertToOpportunityCondition, allStatuses)
    }

    clientCategoryChanged();
    contactMethodChanged();
    serviceTypeChanged()
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

const clientCategoryChanged = (e = null) => {
    const value = e ? e.target.value : crud.value.client_categories;
    isCompanyNameRequired.value = (value === 'F');
}

// -----------------------------------------------------

const serviceTypeChanged = async () => {
    const options = await prepareSelect(['services'], null, null, { 'services': { 'type': crud.value.service_type ??= 'O' } })
    select.value.services = options.services
    if (!options.services.find(s => s.value === crud.value.service_id)) {
        crud.value.service_id = null;
    }
}

// -----------------------------------------------------

const contactMethodChanged = (e = null) => {
    const value = e ? e.target.value : crud.value.contact_method;
    contactValidation.value = (value === 'E') ? 'E' : 'T';
}

// -----------------------------------------------------

const refreshAlertsIfNeeded = () => {
    if (crud.value.id) {
        if (previousTraderId !== crud.value.trader_id) {
            const event = new CustomEvent('refresh-alerts-list', { detail: { sourceId: crud.value.id } });
            window.dispatchEvent(event);
        }
    }
}

// -----------------------------------------------------

const setButtonsConditions = (allowedSymbols, variable, allStatuses) => {
    const allowedIds = allStatuses
        .filter(s => allowedSymbols.includes(s.status_symbol))
        .map(s => s.id);
    variable.value = allowedIds.includes(crud.value.status_id);
}

// -----------------------------------------------------

const setRefuse = async () => {
    leadData.value = { ...crud.value }
    leadFormProps.value = props.formProps
    isSetRefuseModalOpen.value = true;
}

// -----------------------------------------------------

const setClassify = async () => {
    leadData.value = { ...crud.value }
    leadFormProps.value = props.formProps
    isSetClassifyModalOpen.value = true;
}

// -----------------------------------------------------

const openConvertConfirmationWindow = () => {
    isConvertConfirmationOpen.value = true;
}

// -----------------------------------------------------

const convertToOpportunity = async () => {
    const formData = {
        'id': crud.value.id,
        'status_symbol': 'SYM_CONVERTED',
    }

    const response = await getFromRoute('lead-status-set', formData, 'post');
    screenMessage({ ...response })

    if (response.success) {
        props.formProps.closeModal()
        props.formProps.getLazyData()
    }
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
